import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';

@Component({
  selector: 'app-transaction-tab',
  templateUrl: './transaction-tab.component.html',
  styleUrls: ['./transaction-tab.component.scss']
})
export class TransactionTabComponent implements OnInit {

  static that: TransactionTabComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;
  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    lable: 'From Date',
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    lable: 'To Date',
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
  ) {
    TransactionTabComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (this.Id) {
        this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
      }
    }
  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: "No Records Found",
      data: [],
      columnDetails: [],
      actionList: [],
      isColumnNameShow: true,
    };
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.SearchValue = searchValue;
    this.payload.CompanyId = this.CompanyId;
    this.payload.FromDate = this.data.Fromdate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Id = Id;
    this.payload.ReferenceType = this.referenceType;

    this._appService.Post("VehicleMaster", "getTransactions", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].Count;

        let i = 0;
        response.forEach(function (value, prop, obj) {
          if (i == 0) {
            delete value["Count"];
            TransactionTabComponent.that.reportHeader = Object.getOwnPropertyNames(value);
          }
          i++;
        });

        this.tableDetails.columnDetails = [];
        for (const item of this.reportHeader) {
          var obj: any = {};
          obj.columnName = item;
          obj.dataFieldName = item;
          if (item === 'RouteTo') {
            continue;
          }

          if (item == 'BillNo') {
            obj.divType = 'routebylink'
          }
          this.tableDetails.columnDetails.push(obj);
        }

        console.log("Final Table Details:", this.tableDetails);


      }
      this.assignTableFields(pageNo, perPage, response)
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


}
